<mat-toolbar class="header" *ngIf="userRole$ | async as userRole">
  <img class="logo" height="60" [src]="logo" alt="Canton de Genève" />

  <app-user-profile (themeChanged)="changeLogo($event)"></app-user-profile>

  <ng-container *ngIf="userRole.accesApplication">
    <div class="divider"></div>
    <app-monitoring></app-monitoring>
  </ng-container>

  <ng-container *ngIf="userRole.accesAlarmes">
    <div class="divider"></div>
    <app-alarm></app-alarm>
  </ng-container>

  <ng-container *ngIf="userRole.gestionSession">
    <div class="divider"></div>
    <app-session></app-session>
    <div class="divider"></div>
  </ng-container>

  <section fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
    <ng-container *ngIf="userRole.accesVec">
      <mat-icon
        #mapWidget
        class="clickable"
        color="primary"
        (click)="addComponent('MapVecComponent', $event)"
        (keypress)="addComponent('MapVecComponent', $event)"
        matTooltip="VEC"
      >
        public
      </mat-icon>
    </ng-container>

    <ng-container *ngIf="userRole.gestionSession && (existsSessionForCurrentUser$ | async)">
      <mat-icon
        #mapEditWidget
        class="clickable"
        color="primary"
        (click)="addComponent('MapEditComponent', $event)"
        (keypress)="addComponent('MapEditComponent', $event)"
        matTooltip="EFT"
      >
        edit
      </mat-icon>
    </ng-container>

    <ng-container *ngIf="userRole.gestionEs">
      <mat-icon
        #esListWidget
        color="primary"
        (click)="addComponent('EsListComponent', $event)"
        (keypress)="addComponent('EsListComponent', $event)"
        class="clickable"
        matTooltip="Evènements Spontanés"
      >
        event
      </mat-icon>
    </ng-container>

    <ng-container *ngIf="userRole.gestionSp">
      <mat-icon
        #spListWidget
        color="primary"
        (click)="addComponent('SpListComponent', $event)"
        (keypress)="addComponent('SpListComponent', $event)"
        class="clickable"
        matTooltip="Scenarii Préprogrammés"
      >
        menu_book
      </mat-icon>
    </ng-container>

    <ng-container *ngIf="userRole.definitionPgm">
      <mat-icon
        #pgmListWidget
        color="primary"
        (click)="addComponent('PgmListComponent', $event)"
        (keypress)="addComponent('PgmListComponent', $event)"
        class="clickable"
        matTooltip="Plans de Gestion Mobilité"
      >
        emoji_transportation
      </mat-icon>
    </ng-container>

    <ng-container *ngIf="userRole.accesEquipements">
      <mat-icon
        #equipmentListWidget
        color="primary"
        (click)="addComponent('EquipmentListComponent', $event)"
        (keypress)="addComponent('EquipmentListComponent', $event)"
        class="clickable"
        matTooltip="Equipements"
      >
        construction
      </mat-icon>
    </ng-container>

    <ng-container *ngIf="userRole.accesAlarmes">
      <mat-icon
        #alarmeListWidget
        color="primary"
        (click)="addComponent('AlarmeListComponent', $event)"
        (keypress)="addComponent('AlarmeListComponent', $event)"
        class="clickable"
        matTooltip="Alarmes"
      >
        alarm
      </mat-icon>
    </ng-container>

    <ng-container *ngIf="userRole.accesAvancement">
      <mat-icon
        #avancementListWidget
        color="primary"
        (click)="addComponent('AvancementListComponent', $event)"
        (keypress)="addComponent('AvancementListComponent', $event)"
        class="clickable"
        matTooltip="Avancements"
      >
        update
      </mat-icon>
    </ng-container>

    <ng-container *ngIf="userRole.accesHistorique">
      <mat-icon
        #historiqueWidget
        class="clickable"
        color="primary"
        (click)="addComponent('HistoriqueComponent', $event)"
        (keypress)="addComponent('HistoriqueComponent', $event)"
        matTooltip="Historique"
      >
        history
      </mat-icon>
    </ng-container>

    <ng-container *ngIf="userRole.accesLogs">
      <mat-icon
        #logsListWidget
        color="primary"
        (click)="addComponent('LogListComponent', $event)"
        (keypress)="addComponent('LogListComponent', $event)"
        class="clickable"
        matTooltip="Logs"
      >
        reviews
      </mat-icon>
    </ng-container>
  </section>
</mat-toolbar>
